import { mount } from 'svelte';
import Home from './Home.svelte';
// The same design system and base as the till and the dashboard, then the
// site's own page rules.
import '../design.css';
import '../base.css';
import './site.css';

const target = document.getElementById('app');
if (!target) {
	throw new Error('the mount point #app is missing from site/index.html');
}

export default mount(Home, { target });
